import React from 'react';

const SharpChevronDownIcon = () => {
  return (
    <svg width='13' height='12' viewBox='0 0 13 12' fill='none'>
      <path
        d='M2.59673 3.16038H1.56146C1.47173 3.16038 1.42218 3.26351 1.47709 3.33315L6.19271 9.37065C6.2326 9.42195 6.28369 9.46345 6.34206 9.49201C6.40043 9.52056 6.46456 9.5354 6.52954 9.5354C6.59452 9.5354 6.65865 9.52056 6.71702 9.49201C6.7754 9.46345 6.82648 9.42195 6.86637 9.37065L11.582 3.33315C11.6369 3.26217 11.5874 3.16038 11.4976 3.16038H10.4624C10.3967 3.16038 10.3338 3.19118 10.2936 3.24208L6.53021 8.06351L2.76548 3.24208C2.7253 3.19118 2.66235 3.16038 2.59673 3.16038V3.16038Z'
        fill='black'
      />
    </svg>
  );
};

export default SharpChevronDownIcon;
